import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScheduleValuesRoutingModule } from './schedule-values-routing.module';
import { ScheduleValuesComponent } from './schedule-values.component';
import { MdbGlobalModule } from '../mdb-global.module';
import { DxTooltipModule, DxAccordionModule, DxAutocompleteModule, DxButtonModule, DxNumberBoxModule, DxCheckBoxModule, DxDataGridModule, DxDateBoxModule, DxDropDownBoxModule, DxDropDownButtonModule, DxPopupModule, DxRangeSliderModule, DxScrollViewModule, DxSelectBoxModule, DxSliderModule, DxTagBoxModule, DxTemplateModule, DxTextAreaModule, DxTextBoxModule, DxTreeListModule, DxTreeViewModule, DxFileUploaderModule } from 'devextreme-angular';

import { SharedDatagridModule } from '../shared-datagrid/shared-datagrid.module';
import { NewPartsModule } from 'src/app/pages/inventory/parts/new-part/new-part.module';


@NgModule({
  declarations: [
    ScheduleValuesComponent
  ],
  imports: [
    CommonModule,
    ScheduleValuesRoutingModule,
    MdbGlobalModule,
    DxAccordionModule,
    DxButtonModule,
    DxTextBoxModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxDateBoxModule,
    DxAutocompleteModule,
    DxCheckBoxModule,
    DxDataGridModule,
    DxNumberBoxModule,
    DxPopupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxRangeSliderModule,
    DxTemplateModule,
    DxTagBoxModule,
    DxSliderModule,
    DxDropDownButtonModule,
    DxTextAreaModule,
    SharedDatagridModule,
    DxFileUploaderModule,
    DxTooltipModule,
    NewPartsModule
  ],
  exports: [
    ScheduleValuesComponent,
    MdbGlobalModule,
    DxAccordionModule,
    DxButtonModule,
    DxTextBoxModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxDateBoxModule,
    DxAutocompleteModule,
    DxCheckBoxModule,
    DxDataGridModule,
    DxPopupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxRangeSliderModule,
    DxTemplateModule,
  ],
  schemas: [NO_ERRORS_SCHEMA]

})
export class ScheduleValuesModule { }
